"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenObj = void 0;
const lodash_1 = require("lodash");
const flattenObj = (obj, path = []) => {
    if ((0, lodash_1.isPlainObject)(obj)) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return (0, lodash_1.reduce)(obj, (acc, value, key) => (Object.assign(Object.assign({}, acc), (0, exports.flattenObj)(value, [...path, key]))), {});
    }
    if (path.length < 1) {
        throw new Error(`Object "${obj}" cannot be flattened`);
    }
    return { [path.join('.')]: obj };
};
exports.flattenObj = flattenObj;
